// extracted by mini-css-extract-plugin
module.exports = {"root":"ActionsSlot_root__32rVg"};